import { Button } from 'uikit'
import { CheckboxForm, Heading, InputForm, SelectForm, TextAreaForm } from 'uikit'
import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  Form,
  FormGrid,
  FormHeading,
  FormSection,
  HeadingContainer,
} from 'uikit/layout'
import { InputTimeForm, InputDateForm } from 'uikit/FormStateComponents'
import { Field, Formik } from 'formik'
import moment from 'moment'
import { useHistory, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import { Delete } from './components/Delete/Delete'
import { IconUploaderForm } from './components/IconUploaderForm'
import { useCreateBannerItem } from './services/useCreateBannerItem'
import { useFetchBannerItem } from './services/useFetchBannerItem'
import { useUpdateBannerItem } from './services/useUpdateBannerItem'
import {
  bannerIdentificationId,
  bannerIdentificationOptions,
  bannerTypes,
} from '../Banners.constants'

const isInvalidTime = (time) => {
  return moment(time, 'HH:mm', true).isValid()
}

const isInvalidDate = (date) => {
  return moment(date, 'DD.MM.YYYY', true).isValid()
}

const formSchema = Yup.object().shape({
  subject: Yup.string().required('Обязательное поле тема'),
  body: Yup.string().required('Обязательное поле сообщение'),
  locale: Yup.string().required('Обязательное поле язык'),
  bannerType: Yup.string().required('Обязательное поле тип'),
  severity: Yup.string().test(
    'severity',
    'Заполните поле важность',
    (e) => !Number(isNaN(e) || e < 0)
  ),
  start: Yup.object({
    date: Yup.string().test('startDate', 'Заполните поле дата старта', (e) => isInvalidDate(e)),
    time: Yup.string().test('startTime', 'Заполните поле время старта', (e) => isInvalidTime(e)),
  }),
  end: Yup.object({
    date: Yup.string().test('endDate', 'Заполните поле дата финиша', (e) => isInvalidDate(e)),
    time: Yup.string().test('endTime', 'Заполните поле время финиша', (e) => isInvalidTime(e)),
  }),
})

const format = {
  date: 'DD.MM.YYYY',
  time: 'HH:mm',
}

export const Item = () => {
  const history = useHistory()
  const { id } = useParams()
  const isNew = !id

  const { isLoading, data } = useFetchBannerItem(id)
  const { mutate: createItem } = useCreateBannerItem()
  const { mutate: updateItem } = useUpdateBannerItem()

  const handleBack = () => {
    history.goBack()
  }

  const handleForm = async (values) => {
    const startDate = moment(
      `${values?.start.date} ${values?.start.time}`,
      `${'DD.MM.YYYY'} ${'HH:mm'}`
    ).format()
    const endDate = moment(
      `${values?.end.date} ${values?.end.time}`,
      `${'DD.MM.YYYY'} ${'HH:mm'}`
    ).format()

    const dataRequest = {
      ...values,
      isActive: values?.isActive ? 1 : 0,
      severity: Number(values?.severity),
      start: startDate,
      end: endDate,
      maxVersionAndroid: values?.maxVersionAndroid === '' ? null : values?.maxVersionAndroid,
      maxVersionIOs: values?.maxVersionIOs === '' ? null : values?.maxVersionIOs,
      minVersionAndroid: values?.minVersionAndroid === '' ? null : values?.minVersionAndroid,
      minVersionIOs: values?.minVersionIOs === '' ? null : values?.minVersionIOs,
      identifications: values?.identifications.map((item) => ({
        identificationState: item,
        id: bannerIdentificationId[item],
      })),
    }

    if (isNew) {
      createItem(dataRequest)
    } else {
      updateItem({ id, data: dataRequest })
    }

    handleBack()
  }

  return (
    <Container>
      <CardContainer onBack={handleBack} indentTop={120}>
        <ContentContainer>
          <ContentContainerColumn>
            <HeadingContainer>
              <Heading>{isNew ? 'Создание баннера' : 'Обновление баннера'}</Heading>
              {!isNew && <Delete id={id} />}
            </HeadingContainer>
            <Formik
              initialValues={{
                imgView: data?.imgView ?? null,
                identifications: data?.identifications
                  ? data.identifications.map((item) => item?.identificationState)
                  : [],
                group: data?.group ?? '',
                subject: data?.subject ?? '',
                body: data?.body ?? '',
                locale: data?.locale ?? '',
                bannerType: data?.bannerType ?? '',
                severity: data?.severity ?? '0',
                maxVersionAndroid: data?.maxVersionAndroid ?? '',
                maxVersionIOs: data?.maxVersionIOs ?? '',
                minVersionAndroid: data?.minVersionAndroid ?? '',
                minVersionIOs: data?.minVersionIOs ?? '',
                end: {
                  date: data?.end ? moment(data?.end).format(format.date) : '',
                  time: data?.end ? moment(data?.end).format(format.time) : '',
                },
                start: {
                  date: data?.start ? moment(data?.start).format(format.date) : '',
                  time: data?.start ? moment(data?.start).format(format.time) : '',
                },
                tags: data?.tags,
                isActive: data?.isActive === 1,
              }}
              onSubmit={handleForm}
              validationSchema={formSchema}
              validateOnMount
              enableReinitialize
            >
              {(props) => (
                <Form
                  onSubmit={props.handleSubmit}
                  footer={
                    <Button type="submit" colorPalette="orange" loading={isLoading}>
                      {isNew ? 'Создать' : 'Обновить'}
                    </Button>
                  }
                >
                  <FormSection>
                    <Field
                      name="imgView"
                      label="Картинка"
                      component={IconUploaderForm}
                      disabled={isLoading}
                      loading={isLoading}
                    />
                    <Field name="group" component={InputForm} label="Группа" disabled={isLoading} />
                    <Field name="subject" component={InputForm} label="Тема" disabled={isLoading} />
                    <Field
                      name="identifications"
                      component={SelectForm}
                      placeholder=""
                      label="Группа пользователей"
                      disabled={isLoading}
                      options={bannerIdentificationOptions}
                      isMulti
                    />
                    <Field
                      name="body"
                      component={TextAreaForm}
                      label="Сообщение"
                      minH="160px"
                      disabled={isLoading}
                    />
                    <FormGrid columns={2}>
                      <Field
                        disabled={isLoading}
                        name="bannerType"
                        label="Тип"
                        component={SelectForm}
                        placeholder="Выберите ..."
                        options={[
                          {
                            label: 'Info',
                            value: bannerTypes.info,
                          },
                          {
                            label: 'Alert',
                            value: bannerTypes.alert,
                          },
                          {
                            label: 'Market',
                            value: bannerTypes.market,
                          },
                        ]}
                      />
                      <Field
                        name="severity"
                        component={InputForm}
                        label="Важность"
                        disabled={isLoading}
                      />
                    </FormGrid>
                    <Field
                      disabled={isLoading}
                      name="locale"
                      label="Язык"
                      component={SelectForm}
                      placeholder="Выберите ..."
                      options={[
                        {
                          label: 'Русский (ru)',
                          value: 'ru',
                        },
                        {
                          label: 'Английский (en)',
                          value: 'en',
                        },
                        {
                          label: 'Армянский (hy)',
                          value: 'hy',
                        },
                      ]}
                    />
                    <Field name="tags" component={InputForm} label="Теги" disabled={isLoading} />
                  </FormSection>
                  <FormSection>
                    <FormHeading>Время работы</FormHeading>
                    <FormGrid columns={2}>
                      <Field
                        isHideError
                        disabled={isLoading}
                        name="start.date"
                        label="Дата старта"
                        placeholder="01.01.2023"
                        component={InputDateForm}
                      />
                      <Field
                        isHideError
                        disabled={isLoading}
                        name="start.time"
                        label="Время"
                        placeholder="00:00"
                        component={InputTimeForm}
                      />
                    </FormGrid>
                    <FormGrid columns={2}>
                      <Field
                        isHideError
                        disabled={isLoading}
                        name="end.date"
                        label="Дата финиша"
                        placeholder="01.01.2023"
                        component={InputDateForm}
                      />
                      <Field
                        isHideError
                        disabled={isLoading}
                        name="end.time"
                        label="Время"
                        placeholder="00:00"
                        component={InputTimeForm}
                      />
                    </FormGrid>
                  </FormSection>
                  <FormSection>
                    <FormHeading>Ограничения</FormHeading>
                    <FormGrid columns={2}>
                      <Field
                        isHideError
                        disabled={isLoading}
                        name="maxVersionAndroid"
                        label="Максимальная версия Android"
                        placeholder="Для всех"
                        component={InputForm}
                      />
                      <Field
                        isHideError
                        disabled={isLoading}
                        name="minVersionAndroid"
                        label="Минимальная версия Android"
                        placeholder="Для всех"
                        component={InputForm}
                      />
                    </FormGrid>
                    <FormGrid columns={2}>
                      <Field
                        isHideError
                        disabled={isLoading}
                        name="maxVersionIOs"
                        label="Максимальная версия IOS"
                        placeholder="Для всех"
                        component={InputForm}
                      />
                      <Field
                        isHideError
                        disabled={isLoading}
                        name="minVersionIOs"
                        label="Минимальная версия IOS"
                        placeholder="Для всех"
                        component={InputForm}
                      />
                    </FormGrid>
                  </FormSection>
                  <FormSection>
                    <Field
                      name="isActive"
                      component={CheckboxForm}
                      label="Активно"
                      disabled={isLoading}
                    />
                  </FormSection>
                </Form>
              )}
            </Formik>
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>
    </Container>
  )
}
